<script>
import { LorryReceiptGenerationCategory } from 'pando-constants';
import { uniq, compact, groupBy, uniqBy } from 'lodash';

const LrNumberListOnConfigMixin = {
  methods: {
    computedLE(destinationsList, dropOfflegalEntityList, legalEntityList) {
      const mapDestinationWithLE = destinationsList.reduce((updateDestination, currentDrop) => {
        const _currentDrop = currentDrop;
        const dropOffId = currentDrop.gate_id || currentDrop.location_id;
        const dropEntity = dropOfflegalEntityList.find((_entity) =>
        (_entity.gate_id || _entity.location_id) === dropOffId);
        _currentDrop.legalEntity = dropEntity? dropEntity.legal_entity : 'Default LE';
        _currentDrop.clientLe = dropEntity ? dropEntity.clientLe : '';
        updateDestination.push(_currentDrop);
        return updateDestination;
      }, []);
      const groupDestinationByLE = groupBy(mapDestinationWithLE, _data => `${_data.legalEntity}_${_data.location_id}_${_data.gate_id}`);
      const groupSourceByLE = groupBy(legalEntityList, _data => `${_data.legal_entity}_${_data.location_id}_${_data.gate_id}`);
      let constructLr = [];
      if (Object.keys(groupSourceByLE).length) {
        constructLr = Object.keys(groupSourceByLE).reduce((legalEntityListArr, pickUpLE) => {
        const sourcegateIds = []
        const sourceFirst = groupSourceByLE[pickUpLE][0];
        const mapLEWithSourceAndDestination = Object.values(groupDestinationByLE)
          .reduce((mappedLR, _destinationLEArr) => {
            const destSourcegateIds = _destinationLEArr.map(destination => destination.source_gate_id)
            const destinationLE = _destinationLEArr[0]
            // TODO: this if else will be removed during refactoring Ticket
            if(_destinationLEArr.length === 1 && groupSourceByLE[pickUpLE].length > 1) {
              sourcegateIds.push(...destSourcegateIds)
              if(sourcegateIds.includes(sourceFirst.gate_id) ) {
                const destinationLEMaping = Object.assign({
                  title: this.getLeTitle(sourceFirst, destinationLE),
                  lr_number: '',
                  legal_entity: destinationLE.legalEntity,
                  destination_location_id: destinationLE.location_id,
                  source_location_id: sourceFirst.location_id,
                }, (destinationLE.gate_id) ? { gate_id: destinationLE.gate_id } : {},
                (sourceFirst.gate_id) ? { source_gate_id: sourceFirst.gate_id } : {}
                );
                mappedLR.push(destinationLEMaping);
              }
              return mappedLR;
            } else {
                if(destSourcegateIds.includes(sourceFirst.gate_id) ) {
                  const destinationLEMaping = Object.assign({
                    title: this.getLeTitle(sourceFirst, destinationLE),
                    lr_number: '',
                    legal_entity: destinationLE.legalEntity,
                    destination_location_id: destinationLE.location_id,
                    source_location_id: sourceFirst.location_id,
                  }, (destinationLE.gate_id) ? { gate_id: destinationLE.gate_id } : {},
                  (sourceFirst.gate_id) ? { source_gate_id: sourceFirst.gate_id } : {}
                  );
                  mappedLR.push(destinationLEMaping);
                }
                return mappedLR;
            }
          }, []);
          legalEntityListArr.push(...mapLEWithSourceAndDestination);
          return legalEntityListArr;
      }, []);
      } else {
        constructLr = Object.values(groupDestinationByLE)
          .reduce((mappedLR, _destinationLEArr) => {
            const destinationLE = _destinationLEArr[0]
            let destLeTitle = `${destinationLE.legalEntity}`;
            if (this.$hasFeature('primary_legal_entity') && destinationLE.clientLe) {
              destLeTitle += ` ${destinationLE.clientLe}`;
            }
            const destinationLEMaping = Object.assign({
              title: `Default LE-${destLeTitle}`,
              lr_number: '',
              legal_entity: destinationLE.legalEntity,
              destination_location_id: destinationLE.location_id,
              source_location_id: destinationLE.source_location_id,
            }, (destinationLE.gate_id) ? { gate_id: destinationLE.gate_id } : {},
            (destinationLE.source_gate_id) ? { source_gate_id: destinationLE.source_gate_id } : {}
            );
            mappedLR.push(destinationLEMaping);
            return mappedLR;
          }, []);
      }
      return uniqBy(constructLr, 'title');
    },
    getLeTitle(sourceFirst, destinationLE) {
      let title = '';
      if (this.$hasFeature('primary_legal_entity')) {
        title = `${sourceFirst.legal_entity}`;
        if (sourceFirst.clientLe) {
          title += ` (${sourceFirst.clientLe})`;
        }
        title += ` - ${destinationLE.legalEntity}`;
        if (destinationLE.clientLe) {
          title += ` (${destinationLE.clientLe})`;
        }
      } else {
        title = `${sourceFirst.legal_entity}-${destinationLE.legalEntity}`;
      }
      return title;
    },
    getLrNumberDetailsDisplay({
      orderDetails,
      destinationDetails,
      lorryReceipts,
      lrGenerateCategory,
      depotDetails,
      divisionList,
      legalEntityDetails,
      isMultiDropGateConfig
    }) {
      let result = [];
      const defaultLegalEntity = 'Default LE';
      let lrNumberDetailOnConsignee = {};
      if (isMultiDropGateConfig
      && destinationDetails.gate_id) {
        lrNumberDetailOnConsignee = lorryReceipts && lorryReceipts.find(lr =>
          lr.destination_location_id === destinationDetails.location_id &&
          (lr.gate_id === destinationDetails.gate_id));
      } else {
        lrNumberDetailOnConsignee = lorryReceipts && lorryReceipts.find(lr =>
          lr.destination_location_id === destinationDetails.location_id);
      }
      result.push({
        title: 'Lr Number',
        lr_number: lrNumberDetailOnConsignee ? lrNumberDetailOnConsignee.lr_number : '',
        consignee_id: isMultiDropGateConfig && destinationDetails.gate_id ? destinationDetails.gate_id :
          destinationDetails.location_id,
        location_id: destinationDetails.location_id,
      });
      if (lrGenerateCategory === LorryReceiptGenerationCategory.LEGAL_ENTITY_WISE) {
        let destinationsList = [];
        if (orderDetails && orderDetails.destinations.length) {
          if (isMultiDropGateConfig
            && destinationDetails.gate_id) {
            destinationsList = orderDetails.destinations.filter(
              destination => destination.location_id === destinationDetails.location_id &&
                destination.gate_id === destinationDetails.gate_id,
            );
          } else {
            destinationsList = orderDetails.destinations.filter(
              destination => destination.location_id === destinationDetails.location_id,
            );
          }
          const sourceLocationIdList = destinationsList.map(val => val.source_location_id);
          const sourceGateIdList = compact(destinationsList.map(val => val.source_gate_id));
          const destinationGateIdList = compact(destinationsList
          .filter(val => val.gate_id)
          .map(val => val.gate_id));

          let legalEntityList = this.legalEntityDetails
            .filter(val => sourceLocationIdList.includes(val.location_id) &&
          sourceGateIdList.includes(val.gate_id));
          let updatedLE = [];
          if (destinationDetails.gate_id) {
            const dropOfflegalEntityList = this.legalEntityDetails
            .filter(val =>  destinationGateIdList.includes(val.gate_id));
            updatedLE = this.computedLE(destinationsList, dropOfflegalEntityList, legalEntityList)

          } else {
             updatedLE = this.computedLE(destinationsList, [], legalEntityList)
          }
          if (updatedLE && updatedLE.length) {
            result = updatedLE.map((legalEntity) => {
              let lrNumberDetail = null;
              if (isMultiDropGateConfig
              && destinationDetails.gate_id) {
                lrNumberDetail = lorryReceipts && lorryReceipts.find(lrDetail => lrDetail.legal_entity === legalEntity.title &&
                  lrDetail.destination_location_id === destinationDetails.location_id &&
                  lrDetail.gate_id === destinationDetails.gate_id);
              } else {
                lrNumberDetail = lorryReceipts && lorryReceipts.find(lrDetail => lrDetail.legal_entity === legalEntity.title &&
                  lrDetail.destination_location_id === destinationDetails.location_id);
              }
              return Object.assign ({
                title: legalEntity.title,
                lr_number: (lrNumberDetail && lrNumberDetail.lr_number) || '',
                legal_entity: legalEntity || defaultLegalEntity,
                consignee_id: legalEntity.gate_id || legalEntity.destination_location_id,
                location_id: destinationDetails.location_id,
                source_gate_id: legalEntity.source_gate_id || ''
              }, {});
            });
          }
        }
      } else if (lrGenerateCategory === LorryReceiptGenerationCategory.DIVISION_WISE) {
        if (divisionList && divisionList.length) {
          result = divisionList.map((division) => {
            let lrNumberDetail = null;
            if (isMultiDropGateConfig
              && destinationDetails.gate_id) {
              lrNumberDetail = lorryReceipts && lorryReceipts.find(lrDetail => lrDetail.division === division &&
                  lrDetail.destination_location_id === destinationDetails.location_id &&
          (lrDetail.gate_id === destinationDetails.gate_id));
            } else {
              lrNumberDetail = lorryReceipts && lorryReceipts.find(lrDetail => lrDetail.division === division &&
          lrDetail.destination_location_id === destinationDetails.location_id);}
            return {
              title: division,
              lr_number: lrNumberDetail ? lrNumberDetail.lr_number : '',
              division_id: division,
              consignee_id: isMultiDropGateConfig && destinationDetails.gate_id ? destinationDetails.gate_id :
          destinationDetails.location_id,
              location_id: destinationDetails.location_id,
            };
          });
        }
      } else if (lrGenerateCategory === LorryReceiptGenerationCategory.GATE_WISE) {
          let destinationsList = [];
          if (orderDetails && orderDetails.destinations.length) {
            if (isMultiDropGateConfig
            && destinationDetails.gate_id) {
              destinationsList = orderDetails.destinations.filter(
                destination => destination.location_id === destinationDetails.location_id &&
                destination.gate_id === destinationDetails.gate_id,
              );
            } else {
              destinationsList = orderDetails.destinations.filter(
                destination => destination.location_id === destinationDetails.location_id,
              );
            }
          }
          const sourceLocationIdList = uniq(destinationsList.map(val => `${val.source_location_id}_${val.source_gate_id}`));
          let isInDepots = Object.keys(depotDetails).some(val => sourceLocationIdList.includes(val));
          if(isInDepots) { // OUTBOUND movement
            result = sourceLocationIdList.map((depotIdGateId) => {
              let [sourceDepotId, sourceGateId] = depotIdGateId.split('_');
                const gateDetails = depotDetails[depotIdGateId];
                let lrNumberDetail = null;
                if (isMultiDropGateConfig
                && destinationDetails.gate_id) {
                  lrNumberDetail = lorryReceipts && lorryReceipts.find(lrDetail =>
                    lrDetail.source_gate_id === sourceGateId &&
                    lrDetail.destination_location_id === destinationDetails.location_id &&
          (lrDetail.gate_id === destinationDetails.gate_id));
            } else {
                  lrNumberDetail = lorryReceipts && lorryReceipts.find(lrDetail =>
                    lrDetail.source_gate_id === sourceGateId &&
          lrDetail.destination_location_id === destinationDetails.location_id);}
                return {
                  title: gateDetails.name,
                  lr_number: lrNumberDetail ? lrNumberDetail.lr_number : '',
                  source_gate_id: sourceGateId,
                  source_location_id: sourceDepotId,
                  consignee_id: isMultiDropGateConfig && destinationDetails.gate_id ? destinationDetails.gate_id :
          destinationDetails.location_id,
                  location_id: destinationDetails.location_id,
                };
              });
          } else { // INBOUND movement
            result = [];
            let sourceDetails = orderDetails &&
              orderDetails.sources.filter(val => sourceLocationIdList.includes(`${val.location_id}_${val.gate_id}`));
            sourceDetails.forEach(sourceDetail => {
            let lrNumberDetail = null;
            if (isMultiDropGateConfig
            && destinationDetails.gate_id) {
              lrNumberDetail = lorryReceipts && lorryReceipts.find(lrDetail => lrDetail.gate_id === destinationDetails.gate_id &&
                  lrDetail.source_location_id === sourceDetail.location_id &&
                  lrDetail.destination_location_id === destinationDetails.location_id &&
          (lrDetail.gate_id === destinationDetails.gate_id));
            }
            else {
              lrNumberDetail = lorryReceipts && lorryReceipts.find(lrDetail => lrDetail.source_location_id === sourceDetail.location_id &&
          lrDetail.destination_location_id === destinationDetails.location_id);}
            result.push({
              title: (sourceDetail && sourceDetail.details) ?
                sourceDetail.details.name: sourceDetail.address.name,
              lr_number: lrNumberDetail ? lrNumberDetail.lr_number : '',
              source_gate_id: sourceDetail.gate_id,
              source_location_id: sourceDetail.location_id,
              consignee_id: isMultiDropGateConfig && destinationDetails.gate_id ? destinationDetails.gate_id :
          destinationDetails.location_id,
              location_id: destinationDetails.location_id,
            });
          });
        }
      }
      if (result && !result.length) {
        result = [{
          title: 'Lr Number',
          lr_number: '',
        }];
      }
      return result;
    },
    getMaterialLRDisplayDetails({ orderDetails, destinationDetails, lorryReceipts, isMultiDropGateConfig }) {
      const result = [];
      if (orderDetails && orderDetails.material_invoice_map) {
        const matchingInvoices = Object.entries(orderDetails.material_invoice_map)
          .filter(([_, values]) => {
            if (isMultiDropGateConfig && destinationDetails.gate_id) {
              return values.some(value =>
                value.destinationLocationId === destinationDetails.location_id &&
                value.destinationGateId === destinationDetails.gate_id
              );
            } else {
              return values.some(value =>
                value.destinationLocationId === destinationDetails.location_id
              );
            }
          });
        if (matchingInvoices.length > 0) {
          matchingInvoices.forEach(([invoiceNumber, value]) => {
            let matchingLR;
            if (isMultiDropGateConfig && destinationDetails.gate_id) {
              matchingLR = lorryReceipts.find(lr =>
                lr.destination_location_id === destinationDetails.location_id &&
                lr.source_location_id === destinationDetails.source_location_id &&
                lr.gate_id === destinationDetails.gate_id &&
                lr.material_invoice_no === invoiceNumber
              );
            } else {
              matchingLR = lorryReceipts.find(lr =>
                lr.destination_location_id === destinationDetails.location_id &&
                lr.source_location_id === destinationDetails.source_location_id &&
                lr.material_invoice_no === invoiceNumber
              );
            }
            result.push({
              lr_number: matchingLR ? matchingLR.lr_number : '',
              invoiceNo: invoiceNumber,
              consignee_id: isMultiDropGateConfig && destinationDetails.gate_id
                ? destinationDetails.gate_id
                : destinationDetails.location_id,
              location_id: destinationDetails.location_id,
            });
          });
        }
      } else {
        this.$errorMessage({
          message: 'No Material Invoice Found',
        });
      }
      return result;
    }
  },
};
export default LrNumberListOnConfigMixin;
</script>
